import gql from 'graphql-tag';

export default gql`
query getAutoRedirects($groupId: Int!) {
  autoRedirects(object: { group_id: $groupId }) {
    from_path
    to_path
    type
  }
}
`;
